<script lang="ts" setup>
type TotalSumTokenType = {
    name: string;
    totalAmount: number;
};

type TotalSumType = {
    totalAmountUsd: number;
    tokens: TotalSumTokenType[];
};

const props = defineProps<TotalSumType>();

</script>

<template>
  <div v-bind="$attrs"
       class="display-flex layout-total justify-between align-items-center"
  >
    <span class="compact-500-accent">Total</span>
    <div class="display-flex flex-column align-items-end">
      <span v-for="{ name, totalAmount } in props.tokens"
            :key="name"
            class="compact-500-numeric mb-4 color-gray-600 layout-total__token"
      >{{ totalAmount }} {{ name }}</span>

      <span class="compact-500-accent-numeric">~$ {{ props.totalAmountUsd }}</span>
    </div>
  </div>
</template>

<style lang="scss">

.layout-total {
  margin-top: auto;
  margin-bottom: $spacing-600;
  padding-top: $spacing-500;

  &__token {
    color: var(--content-secondary)
  }
}

</style>
